<script setup lang="ts">
type OAuthProvider = {
  icon: string
  label: string
}

const props = defineProps<{
  modelValue?: boolean
  email?: string
  oauthProvider?: OAuthProvider | null
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

function signin() {
  const params = new URLSearchParams(window.location.search)
  params.set('tab', 'login')
  params.delete('signup_data_id')

  const url = new URL('/users/login', window.location.href)
  url.search = params.toString()
  url.hash = props.email ?? ''

  const currentLocation = window.location.href.split('#')[0]
  const newLocation = url.href.split('#')[0]

  if (currentLocation === newLocation) {
    window.location.href = url.toString()
    window.location.reload()
    return
  }

  window.location.href = url.toString()
}
</script>

<template>
  <v-rich-modal
    title="Почта уже зарегистрирована"
    :model-value="props.modelValue"
    @update:model-value="(value: boolean) => emit('update:modelValue', value)"
  >
    <div class="signup-email-modal">
      <p class="text-body">
        Почта <b>{{ props.email }}</b> уже зарегистрирована на сайте МирГоворит. Если это Ваш адрес E-Mail,
        воспользуйтесь входом на сайт.
      </p>

      <p v-if="props.oauthProvider" class="mt-1 text-body">
        После этого Вы сможете привязать аккаунт
        <span class="signup-email-modal__inline-provider">
          <v-icon size="20">{{ props.oauthProvider.icon }}</v-icon>
          <b>{{ props.oauthProvider.label }}</b>
        </span>
        и входить на сайт через него.
      </p>
    </div>

    <template #actions>
      <v-button mode="primary filled block" @click="signin"> Войти </v-button>
      <v-button mode="outlined block" @click="() => emit('update:modelValue', false)"> Отмена </v-button>
    </template>
  </v-rich-modal>
</template>

<style lang="scss">
.signup-email-modal {
  @include desktop {
    max-width: 450px;
  }

  &__inline-provider {
    display: inline-flex;
    align-items: baseline;

    & > .v-icon {
      align-self: center;
      margin-right: 4px;
    }
  }
}
</style>
